// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3XWI4","itemTitle":"ClientEmergencyInfo_itemTitle__1YxCF","itemText":"ClientEmergencyInfo_itemText__1vaHw"};